/**
 * Provincias y cantones de Ecuador - datos para dropdown cascada
 * Fuente: INEC / división administrativa Ecuador
 */
window.ECUADOR_PROVINCES = {
  "ecuador": {
    "provinces": {
      "AZUAY": {
        "cities": [
          "CUENCA",
          "GUALACEO",
          "GIRON",
          "SAN FERNANDO",
          "SANTA ISABEL",
          "CHORDELEG",
          "SIGSIG",
          "PAUTE",
          "EL PAN",
          "CUMBE",
          "GUACHAPALA",
          "LA UNION (AZUAY)",
          "SEVILLA DE ORO",
          "TARQUI (AZUAY)",
          "BANOS",
          "RICAURTE",
          "PONCE ENRIQUEZ",
          "NABON",
          "ONA",
          "PUCARA",
          "SAYUASI"
        ]
      },
      "BOLIVAR": {
        "cities": [
          "GUARANDA",
          "CALUMA",
          "CHILLANES",
          "SAN PABLO DE ATENAS",
          "SAN PEDRO DE GUANUJO",
          "CHIMBO",
          "SAN MIGUEL DE BOLIVAR",
          "ECHEANDIA",
          "1ERO DE MAYO",
          "SAN JOSE DE CHIMBO",
          "BALZAPAMBA",
          "PISAGUA ALTO",
          "PISAGUA BAJO",
          "SAN SIMON",
          "SANTA FE",
          "4 ESQUINAS",
          "ASUNCION",
          "LA MAGDALENA",
          "RECINTO 24 DE MAYO",
          "RECINTO EL PALMAR",
          "RECINTO LA MARITZA",
          "SALINAS (BOLIVAR)",
          "VINCHOA",
          "LAS NAVES",
          "SAN LORENZO"
        ]
      },
      "CANAR": {
        "cities": [
          "LA TRONCAL",
          "CANAR",
          "AZOGUES",
          "MANUEL J CALLE",
          "BIBLIAN",
          "SUSCAL",
          "TAMBO",
          "LA PUNTILLA",
          "VOLUNTAD DE DIOS",
          "COCHANCAY",
          "DUCUR",
          "GUAPAN",
          "INGAPIRCA",
          "JAVIER LOYOLA",
          "DELEG",
          "COJITAMBO"
        ]
      },
      "CARCHI": {
        "cities": [
          "TULCAN",
          "SAN GABRIEL",
          "PIOTER",
          "SANTA MARTHA DE CUBA",
          "MIRA",
          "BOLIVAR",
          "CRISTOBAL COLON",
          "EL ANGEL",
          "HUACA",
          "JULIO ANDRADE",
          "LA PAZ",
          "SAN ISIDRO (CARCHI SAN GA",
          "GARCIA MORENO",
          "CHITAN DE NAVARRETES",
          "CUESACA",
          "SANDIAL"
        ]
      },
      "CHIMBORAZO": {
        "cities": [
          "RIOBAMBA",
          "ALAUSI",
          "CHAMBO",
          "COLTA",
          "GUAMOTE",
          "EL GUANO",
          "PENIPE",
          "SAN LUIS (CHIMBORAZO)",
          "CHUNCHI",
          "PALLATANGA",
          "CUMANDA",
          "LICAN",
          "SAN ANDRES",
          "CAJABAMBA",
          "YARUQUIES"
        ]
      },
      "COTOPAXI": {
        "cities": [
          "LATACUNGA",
          "SALCEDO",
          "LA MANA",
          "SAQUISILI",
          "LASSO",
          "PUJILI",
          "BELISARIO QUEVEDO",
          "CHIPUALO",
          "GUAYTACAMA",
          "MULALAO",
          "MULALILLO",
          "PANZALEO",
          "PASTOCALLE",
          "PATAIN",
          "RUMIPAMBA",
          "SAN MARCOS",
          "TANICUCHI",
          "TOACASO",
          "YANAYACU",
          "EL CORAZON",
          "PANGUA",
          "SIGCHOS",
          "ANCHILIVI",
          "POALO",
          "LA VICTORIA",
          "MORASPUNGO",
          "SANTA ANA (COTOPAXI)",
          "ZUMBAHUA"
        ]
      },
      "EL ORO": {
        "cities": [
          "MACHALA",
          "SANTA ROSA (EL ORO)",
          "HUAQUILLAS",
          "PASAJE",
          "PINAS",
          "EL GUABO",
          "ARENILLAS",
          "ZARUMA",
          "EL CAMBIO",
          "PUERTO BOLIVAR",
          "LA AVANZADA",
          "PORTOVELO",
          "BUENA VISTA",
          "LA PEANA",
          "LOMA DE FRANCO",
          "PUERTO HUALTACO",
          "BALSAS",
          "MARCABELI",
          "3 CERRITOS (PASAJE)",
          "BAJO ALTO",
          "BARBONES",
          "BELLAMARIA",
          "CANA QUEMADA",
          "EL PACHE",
          "EL PORTON",
          "LA IBERIA",
          "PUERTO JELI",
          "RIO BONITO",
          "SAN VICENTE DEL JOBO",
          "SHUMIRAL",
          "LOURDES",
          "PACCHA",
          "LA VICTORIA"
        ]
      },
      "ESMERALDAS": {
        "cities": [
          "ESMERALDAS",
          "ATACAMES",
          "LA CONCORDIA",
          "QUININDE",
          "MUISNE",
          "LA INDEPENDENCIA",
          "SAME",
          "SUA",
          "TONSUPA",
          "TACHINA",
          "LA UNION (QUININDE)",
          "SAN LORENZO",
          "VICHE",
          "BORBON",
          "TONCHIGUE",
          "LAGARTO",
          "RIO VERDE",
          "LA Y DE CALDERON",
          "LAS PENAS"
        ]
      },
      "GUAYAS": {
        "cities": [
          "GUAYAQUIL",
          "MILAGRO",
          "LA PUNTILLA",
          "NARANJAL",
          "PLAYAS",
          "DURAN",
          "DAULE",
          "EL TRIUNFO",
          "BALZAR",
          "SAMBORONDON",
          "PEDRO CARBO",
          "BUCAY",
          "GENERAL VERNAZA",
          "KM. 26",
          "EL MORRO",
          "YAGUACHI",
          "CHONGON",
          "TARIFA",
          "LOS TINTOS",
          "SALITRE",
          "LAUREL",
          "SABANILLA (PEDRO CARBO)",
          "SANTA LUCIA",
          "PALESTINA",
          "COLIMES",
          "NOBOL",
          "PETRILLO",
          "LOMAS DE SARGENTILLO",
          "ISIDRO AYORA",
          "CERECITA",
          "SAN ISIDRO (GUAYAS)",
          "PROGRESO",
          "POSORJA",
          "BASE TAURA",
          "PUERTO INCA",
          "BALAO CHICO",
          "TENGUEL",
          "BALAO",
          "SAN LORENZO",
          "ROBERTO ASTUDILLO",
          "MARCELINO MARIDUENA",
          "NARANJITO",
          "MARISCAL SUCRE",
          "JUJAN",
          "SIMON BOLIVAR",
          "EL NATO",
          "LA MARAVILLA",
          "ENGABAO",
          "LA T DE SALITRE",
          "LA TOMA",
          "LAS ANIMAS",
          "LAS MERCEDES (NARANJAL)",
          "LORENZO DE GARAICOA",
          "MATILDE ESTHER",
          "PUENTE LUCIA",
          "PUERTO DEL ENGABAO",
          "SAN CARLOS (BALAO)",
          "SANTA RITA (BALAO)",
          "VILLA NUEVA",
          "VIRGEN DE FATIMA KM 26",
          "3 POSTES",
          "BOCA DE CANA",
          "BOLICHE",
          "CIEN FAMILIA",
          "COLORADAL",
          "DATA DE PLAYAS",
          "SAN ANTONIO (PLAYAS)",
          "CHIVERIA",
          "ALFREDO BAQUERIZO MORENO",
          "ELOY ALFARO - DURAN",
          "GENERAL ANTONIO ELIZALDE",
          "SAN JACINTO DE YAGUACHI",
          "URBINA JADO - SALITRE",
          "NUEVA UNION (NARANJAL)",
          "EL DESEO",
          "INGENIO SAN CARLOS",
          "EL EMPALME",
          "MANUEL J CALLE",
          "TAURA",
          "5 DE JUNIO (MILAGRO)",
          "CHURUTE",
          "JESUS MARIA",
          "JUNQUILLAL",
          "LA VICTORIA"
        ]
      },
      "IMBABURA": {
        "cities": [
          "IBARRA",
          "ATUNTAQUI",
          "OTAVALO",
          "ALPACHACA",
          "ANDRADE MARIN",
          "CARANQUI",
          "CHALTURA",
          "NATABUELA",
          "PRIORATO",
          "QUIROGA",
          "SAN ROQUE",
          "SAN ANTONIO DE IBARRA",
          "PIMAMPIRO",
          "SAN PABLO DEL LAGO",
          "COTACACHI",
          "ADUANA",
          "CHORLAVI",
          "EL OLIVO",
          "EL RETORNO",
          "PINSAQUI",
          "PUERTO LAGO",
          "SAN JOSE",
          "SANTO DOMINGO IMBABURA",
          "YAGUARCOCHA",
          "ANTONIO ANTE",
          "URCUQUI",
          "SAN LUIS (IMBABURA)",
          "YACHAY"
        ]
      },
      "LOJA": {
        "cities": [
          "LOJA",
          "GONZANAMA",
          "SOZORANGA",
          "CATAMAYO",
          "SARAGURO",
          "VILCABAMBA",
          "CARIAMANGA",
          "ALAMOR",
          "MACARA",
          "ZAPOTILLO",
          "PINDAL",
          "CATACOCHA",
          "CELICA",
          "CHAGUARPAMBA",
          "MALACATOS",
          "POZUL",
          "SAN LUCAS",
          "SANTIAGO",
          "OLMEDO (LOJA)",
          "AMALUZA",
          "EL INGENIO",
          "QUILANGA",
          "EL LUCERO",
          "PALTAS",
          "SABANILLA",
          "ROBLONES",
          "LA CEIBA",
          "ALGARROBILLO",
          "CRUZPAMBA",
          "RIO PLAYAS",
          "EL EMPALME"
        ]
      },
      "LOS RIOS": {
        "cities": [
          "BABAHOYO",
          "QUEVEDO",
          "VENTANAS",
          "BUENA FE",
          "SAN CAMILO",
          "VINCES",
          "QUINSALOMA",
          "LAS NAVES",
          "URDANETA",
          "ZAPOTAL (LOS RIOS)",
          "VALENCIA",
          "EL EMPALME",
          "LA UNION (QUEVEDO)",
          "MOCACHE",
          "SAN CARLOS (LOS RIOS)",
          "PATRICIA PILAR",
          "BABA",
          "ISLA DE BEJUCAL",
          "MONTALVO",
          "PALENQUE",
          "MATA DE CACAO",
          "LA UNION (BABAHOYO)",
          "PUEBLO VIEJO",
          "CATARAMA",
          "SAN JUAN",
          "RICAURTE",
          "CARACOL",
          "ENTRADA DE SAN JUAN",
          "FUMISA",
          "HIDROLITORAL",
          "LA ESPERANZA",
          "LA JULIA",
          "LA UNION (VALENCIA)",
          "NUEVA UNION (LOS RIOS)",
          "PALMISA",
          "LOS ANGELES",
          "PUEBLO NUEVO (LOS RIOS)",
          "LA 14 VIA EL PARAISO",
          "SAN LUIS DE PAMBIL",
          "ZULEMA",
          "FEBRES CORDERO",
          "GUARE DE BABA",
          "LA ESMERALDA",
          "PIMOCHA",
          "SAN JOSE DEL TAMBO"
        ]
      },
      "MANABI": {
        "cities": [
          "PORTOVIEJO",
          "MANTA",
          "BAHIA DE CARAQUEZ",
          "CALCETA",
          "PEDERNALES",
          "TOSAGUA",
          "EL CARMEN",
          "MONTECRISTI",
          "CHONE",
          "JIPIJAPA",
          "ABDON CALDERON",
          "BACHILLERO",
          "BELLAVISTA",
          "CANUTO",
          "MACHALILLA",
          "PUEBLO NUEVO (MANABI)",
          "ZULEMA",
          "PICHINCHA",
          "24 DE MAYO",
          "CALDERON (MANABI)",
          "OLMEDO (MANABI)",
          "COLON",
          "CRUCITA",
          "ROCAFUERTE",
          "SANTA ANA (MANABI)",
          "JARAMIJO",
          "LA ESTANCILLA",
          "FLAVIO ALFARO",
          "JUNIN",
          "LEONIDAS PLAZA",
          "SAN VICENTE",
          "CHARAPOTO",
          "SAN JACINTO",
          "JAMA",
          "SAN ISIDRO (BAHIA)",
          "CANOA",
          "PAJAN",
          "PUERTO LOPEZ",
          "CASCOL",
          "RIO CHICO",
          "10 DE AGOSTO",
          "ARENALES",
          "ATAHUALPA MANABI",
          "CANITAS",
          "CHEVE",
          "CIUDAD ALFARO",
          "COAQUE",
          "COJIMIES",
          "DON JUAN",
          "EL MATAL",
          "EL RODEO",
          "LODANA",
          "LOS BAJOS",
          "NUEVO BRICENO",
          "SAN CLEMENTE",
          "SAN PLACIDO",
          "SANCAN",
          "SOSOTE",
          "COLORADO",
          "MACHE",
          "SUCRE BAHIA",
          "RICAURTE",
          "SAN ANTONIO (MANABI)",
          "LA CHORRERA",
          "PLAYA PRIETA",
          "ALHAJUELA",
          "AYACUCHO",
          "EL NARANJO",
          "LA SEQUITA",
          "MEJIA",
          "PAVON",
          "RESBALON",
          "SAN IGNACIO",
          "SESME",
          "ZAPALLO"
        ]
      },
      "MORONA SANTIAGO": {
        "cities": [
          "GUALAQUIZA",
          "MACAS",
          "PALORA",
          "LIMON INDANZA",
          "MENDEZ",
          "SUCUA",
          "HUAMBOYA",
          "LOGRONO",
          "PABLO SEXTO",
          "TIWINTZA"
        ]
      },
      "NAPO": {
        "cities": [
          "TENA",
          "AROSEMENA TOLA",
          "BAEZA",
          "EL CHACO",
          "BORJA",
          "ARCHIDONA",
          "GONZALO PIZARRO",
          "NUEVA ESPERANZA",
          "PUERTO NAPO",
          "COTUNDO",
          "TAZAYACU"
        ]
      },
      "ORELLANA": {
        "cities": [
          "EL COCA",
          "LORETO",
          "JOYA DE LOS SACHAS"
        ]
      },
      "PASTAZA": {
        "cities": [
          "PUYO",
          "FATIMA",
          "SANTA CLARA",
          "SHELL (EL PUYO)",
          "MERA",
          "ARAJUNO "
        ]
      },
      "PICHINCHA": {
        "cities": [
          "QUITO",
          "SAN RAFAEL",
          "SANGOLQUI",
          "MITAD DEL MUNDO",
          "TUMBACO",
          "CUMBAYA",
          "CAYAMBE",
          "BANCOS",
          "LA MERCED",
          "NANEGAL",
          "NANEGALITO",
          "POMASQUI",
          "TANDAPI",
          "ALOAG",
          "AMAGUANA",
          "CONOCOTO",
          "GUAYLLABAMBA",
          "PIFO",
          "PUEMBO",
          "QUINCHE",
          "PEDRO VICENTE MALDONADO",
          "PUERTO QUITO",
          "YARUQUI",
          "TABACUNDO",
          "MACHACHI",
          "TAMBILLO",
          "PUSUQUI",
          "ALANGASI",
          "ALOASI",
          "AYORA",
          "CALACALI",
          "CALDERON",
          "CUSUBAMBA",
          "GUACHALA",
          "JUAN MONTALVO",
          "LA ARMENIA",
          "LLANO CHICO",
          "MONJAS",
          "PINTAG",
          "SAN ANTONIO DE PICHINCHA",
          "SAN JOSE DE MORAN",
          "SAN JUAN DE CALDERON",
          "SAN MIGUEL DE LOS BANCOS",
          "TABABELA",
          "UYUMBICHO",
          "ZAMBISA",
          "LLANO GRANDE",
          "MIRAVALLE",
          "MEJIA"
        ]
      },
      "SANTA ELENA": {
        "cities": [
          "SALINAS (SANTA ELENA)",
          "LA LIBERTAD",
          "SANTA ELENA",
          "MONTANITA",
          "BALLENITA",
          "SANTA ROSA (SANTA ELENA)",
          "MUEY",
          "PUNTA BLANCA",
          "PUNTA CENTINELA",
          "SAN PABLO (SANTA ELENA)",
          "PALMAR",
          "VALDIVIA",
          "MANGLARALTO",
          "SAN PEDRO",
          "ANCONCITO",
          "ANCON",
          "CADEATE",
          "CAPAES",
          "EL TAMBO",
          "JAMBELI MONTEVERDE (SANTA",
          "LIBERTADOR BOLIVAR",
          "JAMBELI MONTEVERDE",
          "OLON",
          "PROSPERIDAD",
          "PUNTA BARANDUA",
          "PUNTA CARNERO",
          "ATAHUALPA",
          "AYANGUE",
          "BARCELONA",
          "CHANDUY",
          "CURIA",
          "LA ENTRADA",
          "OLONCITO",
          "SAN JOSE",
          "SINCHAL"
        ]
      },
      "SANTO DOMINGO": {
        "cities": [
          "SANTO DOMINGO",
          "ALLURIQUIN",
          "KM 14 QUEVEDO",
          "KM 24 QUEVEDO",
          "KM 38.5 VIA QUEVEDO",
          "KM 41 VIA QUEVEDO",
          "LUZ DE AMERICA",
          "NUEVO ISRAEL",
          "VALLE HERMOSO",
          "LAS DELICIAS",
          "PUERTO LIMON",
          "SAN JACINTO DEL BUA"
        ]
      },
      "SUCUMBIOS": {
        "cities": [
          "LAGO AGRIO",
          "SHUSHUFINDI",
          "7 DE JULIO",
          "CASCALES",
          "JIVINO VERDE",
          "LOS RIOS (SUCUMBIOS)",
          "LUMBAQUI",
          "REVENTADOR",
          "SANTA CECILIA",
          "PACAYACU",
          "TARAPOA"
        ]
      },
      "TUNGURAHUA": {
        "cities": [
          "AMBATO",
          "BANOS",
          "PELILEO",
          "PILLARO",
          "PATATE",
          "MOCHA",
          "QUERO",
          "TISALEO",
          "CEVALLOS",
          "SANTA ROSA (AMBATO)",
          "HUAMBALO",
          "QUISAPINCHA",
          "AMBATILLO"
        ]
      },
      "ZAMORA": {
        "cities": [
          "ZAMORA",
          "YANTZAZA",
          "PALANDA",
          "ZUMBA",
          "EL PANGUI",
          "NAMIREZ",
          "PAQUIZHA",
          "CHAMICO",
          "PIUNTZA",
          "GUADALUPE",
          "CUMBARATZA",
          "GUAYZIMI",
          "ZUMBI",
          "28 DE MAYO"
        ]
      }
    }
  }
};
